import { TextField, TextFieldProps } from '@material-ui/core';

export const autoFillSuppressionAttributes = {
  autoComplete: 'off',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-lpignore': 'true',
  'data-form-type': 'other',
};

export const withoutAutoFill = (Component: typeof TextField) => {
  const { autoComplete, ...inputSuppressionAttributes } =
    autoFillSuppressionAttributes;

  const WrapperComponent = (props: TextFieldProps) => {
    const { inputProps, ...rest } = props;

    return (
      <Component
        autoComplete={autoComplete}
        inputProps={{
          ...inputProps,
          ...inputSuppressionAttributes,
        }}
        {...rest}
      />
    );
  };

  return WrapperComponent;
};
